import script from "./Cart3D.vue?vue&type=script&setup=true&lang=js"
export * from "./Cart3D.vue?vue&type=script&setup=true&lang=js"

import "./Cart3D.vue?vue&type=style&index=0&id=bddda406&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bddda406"]])

export default __exports__